// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"603425ec","453":"3077f79a","988":"e5368657"}[chunkId] + ".chunk.js";
};